module.exports = __webpack_public_path__ + "static/media/th.fa8c3c89.svg";